import { render } from "./PedidoView.vue?vue&type=template&id=6c32c003"
import script from "./PedidoView.vue?vue&type=script&lang=js"
export * from "./PedidoView.vue?vue&type=script&lang=js"

import "./PedidoView.vue?vue&type=style&index=0&id=6c32c003&lang=css"

import exportComponent from "D:\\laragon\\www\\balkum-pwa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__